export class IdmClientSecretAutoRotationConfig
{
    constructor(keyvaultName: string, secretName: string) {
        this.keyvaultName = keyvaultName;
        this.secretName = secretName;
        this.id = `${keyvaultName}|${secretName}`;
    }
    keyvaultName: string = '';
    secretName: string = '';
    readonly id: string = '';
}